import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RemunerationSimu from "./pages/RemunerationSimu.jsx";
import AnalyzePage from "./pages/AnalyzePage.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/analyze" element={<AnalyzePage />} />
        <Route path="/simu-remuneration" element={<RemunerationSimu />} />
        <Route path="/remuneration" element={<RemunerationSimu />} />
        <Route path="/simu-remuneration-dirigeant" element={<RemunerationSimu />} />
        <Route path="*" element={<Navigate to="/simu-remuneration" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
